<template>
    <div class="m-banner-wrapper" v-show="bannerUrl">
      <div class="m-img-wrapper" @click="handleHref">
          <img :src="bannerUrl" alt="" >
      </div>
    </div>
</template>

<script>
import { httpRequest, href } from '@igetcool/base-components';

const baseURL = '/app-api-course-server/';

export default {
  name: 'CourseBanner',
  props: {
    coursePid: String,
    courseType: String
  },
  data() {
    return {
      bannerUrl: '',
      jumpUrl: '',
    };
  },
  mounted() {
    this.initBanner();
  },
  methods: {
    initBanner() {
      httpRequest
        .get(baseURL + 'option/study/camp/info.json', {
          productId: this.coursePid,
          productType: this.courseType, // 音频：0，视频：3
          sourceType: 2, // 站外
        }, {
          headers: {
            'App-User-Pid': ''
          }
        })
        .then(res => {
          if (res.code === 10000 && res.data) {
            this.bannerUrl = res.data.img;
            this.jumpUrl = res.data.jumpUrl;
          }
        });
    },
    // 跳转指定页面
    handleHref() {
      this.$coolHref(this.jumpUrl);
    }
  }
};
</script>

<style lang="scss" scoped>
.m-banner-wrapper {
  background-color: #fff;
  padding: 0.1rem 0;
  line-height: 0.01rem;
  .m-img-wrapper {
    width: 3.5rem;
    height: 0.6rem;
    margin: 0 auto;
    border-radius: 0.2rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
